var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider"},[_c('div',{staticClass:"slider__header"},[_c('p',{staticClass:"slider__title",class:{ horizontal: _vm.horizontal }},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"slider__values",class:{ horizontal: _vm.horizontal }},[(_vm.units === 'm')?_c('span',[_vm._v(_vm._s(_vm.horizontal ? ((_vm.$t('from')) + " ") : '')+_vm._s(Number(_vm.value[0])
            .toFixed(_vm.fixed)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' '))+"\n        "+_vm._s(_vm.units)),_c('sup',[_vm._v("2")])]):_vm._e(),(_vm.units === 'm')?_c('span',[_vm._v(_vm._s(_vm.horizontal ? ((_vm.$t('to')) + " ") : '')+_vm._s(Number(_vm.value[1])
            .toFixed(_vm.fixed)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' '))+"\n        "+_vm._s(_vm.units)),_c('sup',[_vm._v("2")])]):_vm._e(),(_vm.units !== 'm')?_c('span',[_vm._v(_vm._s(_vm.horizontal ? ((_vm.$t('from')) + " ") : '')+_vm._s(Number(_vm.value[0])
            .toFixed(_vm.fixed)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' '))+"\n        "+_vm._s(_vm.units))]):_vm._e(),(_vm.units !== 'm')?_c('span',[_vm._v(_vm._s(_vm.horizontal ? ((_vm.$t('to')) + " ") : '')+_vm._s(Number(_vm.value[1])
            .toFixed(_vm.fixed)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ' '))+"\n        "+_vm._s(_vm.units))]):_vm._e()])]),_c('div',{staticClass:"slider__content"},[_c('vue-slider',{key:(_vm.update + "," + _vm.min + "," + _vm.max),staticClass:"slider__range",attrs:{"enable-cross":false,"min":_vm.min,"max":_vm.max,"tooltip":"none","disabled":false,"lazy":_vm.lazy || _vm.islazy,"processStyle":{
        background: '#939498',
        boxShadow: "0px 0px 6px rgba(0,0,0, 0.1)",
        height: '8px',
      },"dotStyle":{
        position: 'absolute',
        top: '-4px',
        width: '9px',
        height: '25px',
        backgroundColor: '#D4AA8A',
        boxShadow: "0px 0px 10px rgba(0,0,0, 0.1)",
        transform: 'translateX(0px)',
        borderRadius: '10px',
      },"railStyle":{
        background: '#ffffff',
        boxShadow: "0px 0px 6px rgba(0,0,0, 0.1)",
        height: '8px',
      },"silent":true},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }